/* Werk-raster: justified rijen (Flickr-stijl) — elke rij wordt zo verdeeld dat hij precies de
   breedte vult, op basis van de eigen verhouding per tegel. Niets wordt bijgesneden: de hoogte
   volgt altijd automatisch uit de echte afbeelding/video op de toegekende breedte.
   Daarnaast: onthullen bij het inscrollen, kleur bij aanraken op telefoon. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MOBILE = 640;
  var state = { lists: [], tiles: [], raf: 0, layoutRaf: 0, bound: false, io: null };

  function ratioOf(tile, onChange) {
    var m = tile.querySelector('.bs-tile-media');
    if (!m) return;
    function set(w, h) {
      if (w > 0 && h > 0) {
        var r = w / h;
        if (Math.abs(r - parseFloat(tile.style.getPropertyValue('--r') || 0)) > 0.01) {
          tile.style.setProperty('--r', r.toFixed(4));
          if (onChange) onChange();
        }
      }
    }
    if (m.tagName === 'VIDEO') {
      if (m.videoWidth) set(m.videoWidth, m.videoHeight);
      else m.addEventListener('loadedmetadata', function () { set(m.videoWidth, m.videoHeight); }, { once: true });
    } else {
      var w = parseInt(m.getAttribute('width'), 10), h = parseInt(m.getAttribute('height'), 10);
      if (w && h) set(w, h);
      else if (m.complete && m.naturalWidth) set(m.naturalWidth, m.naturalHeight);
      else m.addEventListener('load', function () { set(m.naturalWidth, m.naturalHeight); }, { once: true });
    }
  }

  /* Verdeelt tegels in rijen: telkens de rij die het dichtst bij "precies vol" komt wint. */
  function groupRows(items, containerWidth, gap, targetHeight) {
    function scaleOf(group) {
      var sumR = 0;
      for (var i = 0; i < group.length; i++) sumR += group[i].r;
      var totalGap = gap * (group.length - 1);
      return (containerWidth - totalGap) / (sumR * targetHeight);
    }
    var rows = [], current = [];
    for (var i = 0; i < items.length; i++) {
      current.push(items[i]);
      var scaleWith = scaleOf(current);
      if (scaleWith <= 1) {
        if (current.length > 1) {
          var without = current.slice(0, -1);
          if (Math.abs(scaleOf(without) - 1) < Math.abs(scaleWith - 1)) {
            rows.push(without);
            current = [items[i]];
            continue;
          }
        }
        rows.push(current);
        current = [];
      }
    }
    if (current.length) rows.push(current);
    return rows;
  }

  function layoutJustified(list) {
    var tiles = Array.prototype.slice.call(list.querySelectorAll('.bs-tile'));
    if (!tiles.length) return;
    var containerWidth = list.clientWidth;
    if (!containerWidth) return;

    if (window.innerWidth < MOBILE) {
      list.classList.remove('is-justified');
      tiles.forEach(function (t) { t.style.width = ''; });
      return;
    }

    var gap = parseFloat(getComputedStyle(list).columnGap) || 16;
    var targetHeight = Math.min(440, Math.max(230, containerWidth / 3.3));
    var items = tiles.map(function (t) {
      return { el: t, r: parseFloat(getComputedStyle(t).getPropertyValue('--r')) || 1.25 };
    });
    var rows = groupRows(items, containerWidth, gap, targetHeight);

    rows.forEach(function (row) {
      var sumR = 0;
      row.forEach(function (it) { sumR += it.r; });
      var totalGap = gap * (row.length - 1);
      var scale = (containerWidth - totalGap) / (sumR * targetHeight);
      if (scale > 1.35) scale = 1; // te schaars gevulde (laatste) rij niet overdreven uitrekken
      var rowHeight = targetHeight * scale;
      row.forEach(function (it) {
        it.el.style.width = Math.floor(rowHeight * it.r) + 'px';
      });
    });
    list.classList.add('is-justified');
  }

  function layoutAll() {
    state.layoutRaf = 0;
    state.lists.forEach(layoutJustified);
  }
  function queueLayout() { if (!state.layoutRaf) state.layoutRaf = requestAnimationFrame(layoutAll); }

  function update() {
    state.raf = 0;
    var vh = window.innerHeight || 800, mid = vh / 2, best = null, bestD = 1e9;
    state.tiles.forEach(function (t) {
      var r = t.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var c = r.top + r.height / 2, d = Math.abs(c - mid);
      if (d < bestD) { bestD = d; best = t; }
    });
    state.tiles.forEach(function (t) { t.classList.toggle('is-focus', t === best); });
  }
  function queue() { if (!state.raf) state.raf = requestAnimationFrame(update); }

  function init() {
    var lists = document.querySelectorAll('.bs-works');
    if (!lists.length) return;
    if (state.io) state.io.disconnect();
    state.lists = Array.prototype.slice.call(lists);
    state.tiles = [];
    state.lists.forEach(function (list) {
      list.classList.add('bs-zig');
      Array.prototype.forEach.call(list.querySelectorAll('.bs-tile'), function (t) {
        state.tiles.push(t);
        ratioOf(t, queueLayout);
      });
    });
    layoutAll();
    if ('IntersectionObserver' in window) {
      state.io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); state.io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
      state.tiles.forEach(function (t) { state.io.observe(t); });
    } else {
      state.tiles.forEach(function (t) { t.classList.add('is-in'); });
    }
    if ('ResizeObserver' in window) {
      if (state.ro) state.ro.disconnect();
      state.ro = new ResizeObserver(queueLayout);
      state.lists.forEach(function (list) { state.ro.observe(list); });
    }
    if (!state.bound) {
      state.bound = true;
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', function () { queue(); queueLayout(); });
    }
    queue();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
